import { Component } from "vue";
import ArrowIcon from "./ArrowIcon.vue";
import CircleIcon from "./CircleIcon.vue";
import EllipseIcon from "./EllipseIcon.vue";
import HalfCircle from "./HalfCircle.vue";
import HeartIcon from "./HeartIcon.vue";
import HexagonIcon from "./HexagonIcon.vue";
import OctagonIcon from "./OctagonIcon.vue";
import PolygonIcon from "./PolygonIcon.vue";
import IsoscelesTriangle from "./IsoscelesTriangle.vue";
import QuarterCircle from "./QuarterCircle.vue";
import RectangleCutout from "./RectangleCutout.vue";
import RightAngledTriangle from "./RightAngledTriangle.vue";
import RightAngledTriangleMirrored from "./RightAngledTriangleMirrored.vue";
import RoundedRectangle from "./RoundedRectangle.vue";
import SlopedRectangle from "./SlopedRectangle.vue";
import ArchedRectangle from "./ArchedRectangle.vue";
import StarIcon from "./StarIcon.vue";
import TrapezoidIcon from "./TrapezoidIcon.vue";
import RectangleIcon from "@/components/icons/RectangleIcon.vue";
import ShapesIcon from "@/components/icons/ShapesIcon.vue";
import TextIcon from "@/components/icons/TextIcon.vue";
import UploadIcon from "@/components/icons/UploadIcon.vue";
import CrossIcon from "@/components/icons/CrossIcon.vue";
import DrillHoleEdges from "@/components/icons/DrillHoleEdges.vue";
import DrillHoleRadial from "@/components/icons/DrillHoleRadial.vue";
import DrillHoleGrid from "@/components/icons/DrillHoleGrid.vue";
import DrillHoleCustom from "@/components/icons/DrillHoleCustom.vue";
import FlatOvalIcon from "./FlatOvalIcon.vue";
import DrillHolePresetIcon from "@/components/icons/DrillHolePresetIcon.vue";
import SlopedRightRectangle from "./SlopedRightRectangle.vue";
import DropletIcon from "./DropletIcon.vue";
import EggIcon from "./EggIcon.vue";
import KiteIcon from "./KiteIcon.vue";
import BarrelIcon from "./BarrelIcon.vue";
import JewelIcon from "./JewelIcon.vue";
import DownloadIcon from "./DownloadIcon.vue";
import SpecsIcon from "./SpecsIcon.vue";
import ParallogramIcon from "./ParallelogramIcon.vue";
import RectangleNoneEdgesIcon from "./RectangleNoneEdgesIcon.vue";
import RectangleRectangleEdgesIcon from "./RectangleRectangleEdgesIcon.vue";
import CircleCircleNoneIcon from "./CircleCircleNoneIcon.vue";
import RectangleNoneCustomIcon from "./RectangleNoneCustomIcon.vue";
import CircleNoneCustomIcon from "./CircleNoneCustomIcon.vue";
import CircleNoneRadialIcon from "./CircleNoneRadialIcon.vue";
import RectangleCircleEdgesIcon from "./RectangleCircleEdgesIcon.vue";
import RectangleCircleNoneIcon from "./RectangleCircleNoneIcon.vue";
import RectangleNoneGridIcon from "./RectangleNoneGridIcon.vue";
import RectangleRectangleCustomIcon from "./RectangleRectangleCustomIcon.vue";
import RectangleRectangleNoneIcon from "./RectangleRectangleNoneIcon.vue";
import RectangleRoundedrectangleNoneIcon from "./RectangleRoundedrectangleNoneIcon.vue";
import RoundedrectangleNoneCustomIcon from "./RoundedrectangleNoneCustomIcon.vue";
import RoundedrectangleNoneEdgesIcon from "./RoundedrectangleNoneEdgesIcon.vue";
import ParallelogramIconFlipHorizontalIcon from "./ParallelogramIconFlipHorizontalIcon.vue";
import SlopedRectangleFlipHorizontalIcon from "./SlopedRectangleFlipHorizontalIcon.vue";
import SlopedRightRectangleFlipVerticalIcon from "./SlopedRightRectangleFlipVerticalIcon.vue";

const iconComponents = {
	circle: CircleIcon,
	"rounded-rectangle": RoundedRectangle,
	egg: EggIcon,
	ellipse: EllipseIcon,
	"flat-oval": FlatOvalIcon,
	"right-angled-triangle": RightAngledTriangle,
	"right-angled-triangle-mirrored": RightAngledTriangleMirrored,
	"isosceles-triangle": IsoscelesTriangle,
	"half-circle": HalfCircle,
	"quarter-circle": QuarterCircle,
	"sloped-rectangle": SlopedRectangle,
	"sloped-rectangle-flip-horizontal": SlopedRectangleFlipHorizontalIcon,
	"sloped-right-rectangle": SlopedRightRectangle,
	"sloped-right-rectangle-flip-vertical": SlopedRightRectangleFlipVerticalIcon,
	"arched-rectangle": ArchedRectangle,
	trapezoid: TrapezoidIcon,
	hexagon: HexagonIcon,
	octagon: OctagonIcon,
	polygon: PolygonIcon,
	arrow: ArrowIcon,
	star: StarIcon,
	heart: HeartIcon,
	rectangle: RectangleIcon,
	"rectangle-icon": RectangleCutout,
	kite: KiteIcon,
	barrel: BarrelIcon,
	jewel: JewelIcon,
	parallelogram: ParallogramIcon,
	"parallelogram-flip-horizontal": ParallelogramIconFlipHorizontalIcon,
	shapes: ShapesIcon,
	text: TextIcon,
	upload: UploadIcon,
	dxf: UploadIcon,
	cross: CrossIcon,
	edges: DrillHoleEdges,
	radial: DrillHoleRadial,
	grid: DrillHoleGrid,
	custom: DrillHoleCustom,
	preset: DrillHolePresetIcon,
	droplet: DropletIcon,
	download: DownloadIcon,
	specs: SpecsIcon,
	circleCircleNone: CircleCircleNoneIcon,
	circleNoneCustom: CircleNoneCustomIcon,
	circleNoneRadial: CircleNoneRadialIcon,
	rectangleCircleEdges: RectangleCircleEdgesIcon,
	rectangleCircleNone: RectangleCircleNoneIcon,
	rectangleNoneCustom: RectangleNoneCustomIcon,
	rectangleNoneEdges: RectangleNoneEdgesIcon,
	rectangleNoneGrid: RectangleNoneGridIcon,
	rectangleRectangleCustom: RectangleRectangleCustomIcon,
	rectangleRectangleEdges: RectangleRectangleEdgesIcon,
	rectangleRectangleNone: RectangleRectangleNoneIcon,
	rectangleRoundedrectangleNone: RectangleRoundedrectangleNoneIcon,
	roundedrectangleNoneCustom: RoundedrectangleNoneCustomIcon,
	roundedrectangleNoneEdges: RoundedrectangleNoneEdgesIcon,
};

export const getIconComponent = (icon: string): Component => {
	return iconComponents[icon];
};
